/**
 * OVERRIDE PasswordReset.jsx
 * REASON: Default Volto PasswordReset view does not give the correct texts.
 * SemanticUI-free located at the components folder.
 * To override it, override the @plone/volto one instead of
 * this one.
 */

import PasswordReset from '../../../../../components/PasswordReset/PasswordReset';

export default PasswordReset;
